import React, { useState, useContext, createContext } from "react";
import { useCookies } from "react-cookie";
import { useQueryClient } from "react-query";
import { BotContext } from "../../components/context/BotContext";
import { checkToken, userLogin } from "../services";
import { useLocalStorage } from "./useLocalStorage";
import WithAxios from "./WithAxios";
export const authContext = createContext();

export function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return (
    <authContext.Provider value={auth}>
      <WithAxios>{children}</WithAxios>
    </authContext.Provider>
  );
}

export const useAuth = () => {
  return useContext(authContext);
};

function useProvideAuth() {
  const {
    selectedRoom,
    setSelectedRoom,
    setChats,
    setChatsArray,
    setHistoryUser,
    setTokenUser,
    config,
  } = useContext(BotContext);
  const queryClient = useQueryClient();
  const [user, setUser] = useLocalStorage("userinfo");
  const [, setRoom] = useLocalStorage("room");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingToken, setLoadingToken] = useState(true);

  const [cookies, setCookie, removeCookie] = useCookies(["authentication"]);

  const tokenLogin = (token) => {
    setLoadingToken(true);
    checkToken(token)
      .then(({ data }) => {
        setLoadingToken(false);
        setUser({
          accessToken: token,
          loggedIn: true,
        });
      })
      .catch((err) => {
        setLoadingToken(false);
        setUser({
          accessToken: "",
          loggedIn: false,
        });
        throw "error";
      });
  };
  const login = (username, password, history) => {
    setLoading(true);
    setRoom(undefined);
    userLogin(username, password)
      .then(({ data }) => {
        if (data?.status) {
          const {
            data: { isregister, accessToken, refreshToken, username },
          } = data;
          if (isregister) {
            setLoading(false);
            setUser({
              accessToken,
              refreshToken,
              cellnum: username,
              loggedIn: true,
            });
            if (config.withCookie) {
              setCookie(
                "authentication",
                JSON.stringify({
                  isregister,
                  accessToken,
                  refreshToken,
                  username,
                }),
                { path: "/" }
              );
            }

            setError(undefined);
          } else {
            setLoading(false);
            setUser({
              accessToken,
              refreshToken,
              cellnum: username,
              loggedIn: false,
            });
            history?.push("/user-info");
            setError(undefined);
          }
        } else {
          setLoading(false);
          setError(data?.message);
        }
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  };

  const signup = (email, password) => {};
  const logTokenOut = () => {
    setUser({
      token: user?.token,
      loggedIn: false,
    });
  };
  const signout = (history = undefined) => {
    setTokenUser(undefined);
    setUser(undefined);
    setRoom(undefined);
    setSelectedRoom(undefined);
    setChats(undefined);
    setChatsArray(undefined);
    setHistoryUser(undefined);
    history?.replace({ ...history?.location, state: undefined });
    queryClient.removeQueries(["getChatHistory", selectedRoom]);
    queryClient.clear();
    if (config.withCookie) {
      removeCookie("authentication", { path: "/" });
    }
  };

  return {
    user,
    login,
    signup,
    signout,
    error,
    loading,
    setError,
    tokenLogin,
    loadingToken,
    logTokenOut,
  };
}
